import Vue from 'vue'
import VueRouter from 'vue-router'
import NProgress from 'nprogress/nprogress'

// eslint-disable-next-line import/no-cycle
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "public" */ '@/views/Home.vue'),
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '@/views/About.vue'),
    meta: {
      title: 'About',
    },
  },
  {
    path: '/account',
    name: 'account',
    component: () => import(/* webpackChunkName: "account" */ '@/views/account/Account.vue'),
    redirect: '/account/listings/',
    meta: {
      authRequired: true,
    },
    children: [
      {
        path: 'favorites',
        name: 'favorites',
        component: () => import(/* webpackChunkName: "account" */ '@/views/account/AccountFavorites.vue'),
      },
      {
        path: 'listings',
        component: () => import(/* webpackChunkName: "account" */ '@/views/account/AccountListings.vue'),
      },
      {
        path: 'listing/:id',
        component: () => import(/* webpackChunkName: "account" */ '@/views/account/AccountCreateListing.vue'),
        meta: {
          authRequired: true,
        },
      },
      {
        path: 'listings/new',
        name: 'create-listing',
        component: () => import(/* webpackChunkName: "account" */ '@/views/account/AccountCreateListing.vue'),
        meta: {
          authRequired: true,
        },
      },
      {
        path: 'listings/checkout',
        name: 'create-listing-checkout',
        component: () => import(/* webpackChunkName: "account" */ '@/views/account/AccountCreateListingCheckout.vue'),
      },
      {
        path: 'listings/:status?',
        name: 'account-listings',
        component: () => import(/* webpackChunkName: "account" */ '@/views/account/AccountListings.vue'),
      },
      {
        path: 'purchase/:id/:name?',
        component: () => import(/* webpackChunkName: "account" */ '@/views/account/AccountPurchase.vue'),
      },
      {
        path: 'purchases/',
        component: () => import(/* webpackChunkName: "account" */ '@/views/account/AccountPurchases.vue'),
      },
      {
        path: 'purchases/:role/:status?',
        name: 'account-purchases',
        component: () => import(/* webpackChunkName: "account" */ '@/views/account/AccountPurchases.vue'),
      },
      {
        path: 'profile',
        name: 'account-profile',
        component: () => import(/* webpackChunkName: "account" */ '@/views/account/AccountProfile.vue'),
      },
      {
        path: 'billing-history',
        name: 'account-billing-history',
        component: () => import(/* webpackChunkName: "account" */ '@/views/account/AccountBillingHistory.vue'),
      },
      {
        path: 'settings',
        name: 'account-settings',
        component: () => import(/* webpackChunkName: "account" */ '@/views/account/AccountSettings.vue'),
      },
    ],
  },
  {
    path: '/faq',
    name: 'faq',
    component: () => import(/* webpackChunkName: "faq" */ '@/views/FAQ.vue'),
    meta: {
      title: 'Frequently Asked Questions',
    },
  },
  {
    path: '/listing/:id',
    name: 'listing',
    component: () => import(/* webpackChunkName: "public" */ '@/views/Listing.vue'),
  },
  {
    path: '/listing/:id/:displayName',
    name: 'listing-with-name',
    component: () => import(/* webpackChunkName: "public" */ '@/views/Listing.vue'),
  },
  {
    path: '/listing/:id/:displayName/request/review',
    name: 'listing-request-review',
    component: () => import(/* webpackChunkName: "request" */ '@/views/ListingPurchaseRequestReview.vue'),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/listing/:id/:displayName/request/confirm',
    name: 'listing-request-confirm',
    component: () => import(/* webpackChunkName: "request" */ '@/views/ListingPurchaseRequestConfirm.vue'),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/listing/:id/:displayName/request/submitted',
    name: 'listing-request-submitted',
    component: () => import(/* webpackChunkName: "request" */ '@/views/ListingPurchaseRequestSubmitted.vue'),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/listings',
    redirect: to => ({
      path: `/listings/${store.getters['Region/current'].slug}`,
      query: to.query,
    }),
  },
  {
    path: '/listings/:regionSlug',
    name: 'listings',
    component: () => import(/* webpackChunkName: "public" */ '@/views/Listings.vue'),
  },
  {
    path: '/login',
    redirect: '/authentication/login',
  },
  {
    path: '/authentication',
    name: 'authentication',
    component: () => import(/* webpackChunkName: "account" */ '@/views/authentication/Authentication.vue'),
    redirect: '/authentication/login',
    children: [
      {
        path: 'forgot',
        name: 'forgot-password',
        component: () => import(/* webpackChunkName: "forgot" */ '@/views/authentication/AuthenticationForgotPassword.vue'),
        meta: {
          title: 'Forgot Password',
        },
      },
      {
        path: 'login',
        name: 'login',
        component: () => import(/* webpackChunkName: "account" */ '@/views/authentication/AuthenticationLogin.vue'),
        meta: {
          title: 'Login',
        },
      },
      {
        path: 'register',
        name: 'register',
        component: () => import(/* webpackChunkName: "register" */ '@/views/authentication/AuthenticationRegister.vue'),
        meta: {
          title: 'Register for ZoopLocal',
        },
      },
      {
        path: 'reset',
        name: 'set-new-password',
        component: () => import(/* webpackChunkName: "forgot" */ '@/views/authentication/AuthenticationSetNewPassword.vue'),
        meta: {
          title: 'Set New Password',
        },
      },
    ],
  },
  {
    path: '/locations',
    name: 'locations',
    component: () => import(/* webpackChunkName: "locations" */ '@/views/Locations.vue'),
    meta: {
      title: 'Locations',
    },
  },
  {
    path: '/manage',
    name: 'management',
    component: () => import(/* webpackChunkName: "management" */ '@/views/management/Management.vue'),
    redirect: '/manage/review-listings',
    meta: {
      authRequired: true,
      adminRequired: true,
    },
    children: [
      {
        path: 'users',
        name: 'manage-users',
        component: () => import(/* webpackChunkName: "management" */ '@/views/management/ManageUsers.vue'),
        meta: {
          authRequired: true,
          adminRequired: true,
        },
      },
      {
        path: 'review-listings',
        name: 'manage-listings',
        component: () => import(/* webpackChunkName: "management" */ '@/views/management/ReviewListings.vue'),
        meta: {
          authRequired: true,
          adminRequired: true,
        },
      },
      {
        path: 'purchases',
        name: 'manage-purchases',
        component: () => import(/* webpackChunkName: "management" */ '@/views/management/ManagePurchases.vue'),
        meta: {
          authRequired: true,
          adminRequired: true,
        },
      },
      {
        path: 'payments',
        name: 'manage-transactions',
        component: () => import(/* webpackChunkName: "management" */ '@/views/management/ManageTransactions.vue'),
        meta: {
          authRequired: true,
          adminRequired: true,
        },
      },
    ],
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import(/* webpackChunkName: "privacy" */ '@/views/Privacy.vue'),
  },
  {
    path: '/terms',
    name: 'terms',
    component: () => import(/* webpackChunkName: "terms" */ '@/views/Terms.vue'),
  },
  {
    path: '*',
    name: 'NotFound',
    component: () => import(/* webpackChunkName: "notFound" */ '@/views/NotFound.vue'),
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  /* eslint-disable no-else-return */
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition
    } else if (to.hash) {
      return {
        selector: to.hash,
      }
    } else {
      return { x: 0, y: 0 }
    }
  /* eslint-enable no-else-return */
  },
})

// eslint-disable-next-line consistent-return
router.beforeEach(async (routeTo, routeFrom, next) => {
  // If this isn't an initial page load...
  if (routeFrom.name !== null) {
    // Start the route progress bar.
    NProgress.start()
  }

  await store.dispatch('Authentication/setLoggedInUser')

  // Check if auth is required on this route
  // (including nested routes).
  const authRequired = routeTo.matched.some(route => route.meta.authRequired)

  // If auth isn't required for the route, just continue.
  if (!authRequired) return next()

  // If auth is required and the user is logged in...
  if (store.getters['Authentication/isAuthenticated']) {
    return next()
  }

  next({ name: 'login', query: { redirectFrom: routeTo.fullPath } })
})

router.afterEach((to) => {
  if (store.getters['Authentication/isAuthenticated']) {
    store.dispatch('Messages/setUnreadCount')
    store.dispatch('Favorites/setFavoritesCount')
  }
  if (to.meta && to.meta.title) {
    document.title = `${to.meta.title} - ZoopLocal`
  } else {
    document.title = 'ZoopLocal'
  }
  // Complete the animation of the route progress bar.
  NProgress.done()
})


export default router
